import { render, staticRenderFns } from "./PointCredit.vue?vue&type=template&id=e6efcd78"
import script from "./PointCredit.vue?vue&type=script&lang=js"
export * from "./PointCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports